module.exports = __webpack_public_path__ + "img/greek-full-w.199cd68c.svg";